<div>InfinitForm</div>
<div>
    <span>&copy; {{ currentYear }} InfinitForm. All rights reserved.</span>
    <a [href]="aboutUrl()" appTooltip="About" target="_blank">About</a>
    <a [href]="eulaUrl()" appTooltip="EULA" target="_blank">EULA</a>
    <a [href]="privacyUrl()" appTooltip="Privacy" target="_blank">Privacy</a>
    <div class="theme-switcher">
        <span>|</span>
        <span>Theme</span>
        <app-button (click)="changeTheme('light')" [active]="getCurrentTheme() === 'light'"
            variant="header-notification" appTooltip="Change theme to light">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
            </svg>
        </app-button>
        <app-button (click)="changeTheme('dark')" [active]="getCurrentTheme() === 'dark'"
            variant="header-notification" appTooltip="Change theme to dark">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
            </svg>
        </app-button>
        <app-button (click)="changeTheme('system')" [active]="getCurrentTheme() === 'system'"
            variant="header-notification" appTooltip="Change theme to system">
            A
        </app-button>
        @if (showFeedback()) {
            <app-button (click)="onFeedbackClick()" variant="header-notification" appTooltip="Send feedback">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" />
                </svg>
            </app-button>
        }
        <app-button [routerLink]="helpRoute()" variant="header-notification" appTooltip="Help Center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
            </svg>
        </app-button>
    </div>
</div>
